/**
 * True when the app is currently being rendered by the react-snap
 * (headless Chromium) prerendering step during the build, rather than
 * a real user's browser.
 *
 * Use this to skip side effects that should not run repeatedly against
 * production APIs during the prerender crawl (e.g. billing/session calls),
 * while still allowing all static content and SEO metadata to render normally.
 */
export const isPrerendering = () =>
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
